import { render, staticRenderFns } from "./TeamsComponent.vue?vue&type=template&id=1c979906&scoped=true"
import script from "./TeamsComponent.vue?vue&type=script&lang=js"
export * from "./TeamsComponent.vue?vue&type=script&lang=js"
import style0 from "./TeamsComponent.vue?vue&type=style&index=0&id=1c979906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c979906",
  null
  
)

export default component.exports